// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDetailsBase, CriteriaDetailsBaseSchema } from 'api/gen/CriteriaDetailsBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Decimal31CriteriaValues, Decimal31CriteriaValuesSchema } from 'api/gen/Decimal31CriteriaValues';

const requiredPart = t.interface({
  tag: t.literal('DECIMAL_3_1'),
  values: Decimal31CriteriaValuesSchema,
});

export const Decimal31CriteriaDetailsSchema = excess(t.intersection([CriteriaDetailsBaseSchema.type, requiredPart]));

export interface Decimal31CriteriaDetails extends t.TypeOf<typeof Decimal31CriteriaDetailsSchema> {}
